import { InputLabel } from '@mui/material';
import styled from 'styled-components';

export const Label = styled(InputLabel).attrs({ variant: 'standard' })<{
    noMargin?: boolean;
}>`
    position: static;
    margin-bottom: ${({ theme, noMargin }) => !noMargin && theme.spacing(1)};
`;
